export const HIT_REGISTER = 'HIT_REGISTER';
export const GET_REGISTER = 'GET_REGISTER';

export const HIT_LOGIN = 'HIT_LOGIN';
export const GET_LOGIN = 'GET_LOGIN';

export const HIT_LOGOUT = 'HIT_LOGOUT';
export const HIT_RESET = 'HIT_RESET';

export const HIT_CDN = 'HIT_CDN';

export const HIT_FORGOT_PASS = 'HIT_FORGOT_PASS';

export const HIT_COMPANY_REGISTER = 'HIT_COMPANY_REGISTER';
